export default __webpack_public_path__ + "static/media/Volby.32567bc7.png";